import React, {Fragment, useEffect} from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import PropTypes from "prop-types";

import {getReorderedItems} from "../../lookNavigation/lookNavigationFunctions";
import {getCurrentLayout} from "../../../appLayout";
import ShopCategoryVirtualizedGrid from "./shopCategoryVirtualizedGrid";
import {shopContextAction, useShopContext} from "./shopNavItemsContext";
import {scrolledVerticalToTheEnd} from "../../../visComponents/navigation/navUtils";
import {getAdditionalFeaturesOnScroll} from "../../../../api/look-api";
import NavigationLoader from "../../ui/navigationLoader";
import ShopCategoryAside from "./shopCategoryAside";
import ShopCategoryBackNextButtons from "./shopCategoryBackNextButtons";
import MaterialSpinner from "../../../ui/materialSpinner";
import {getLookList} from "../../lookNavigation/lookFunctions";
import {setNavigationLoading} from "../../../../actions/navigationFunctions";

const useSimpleView = window.location.href.includes("quoteremodel");


const ShopCategoryList = (props) => {

  const {featureGroup, filterGroups, selectedFilters, scrollElement, navigationCount, isMobile, windowWidth,
    allFeaturesWereLoaded, groheFiltersSearchText, navigationLoadingActive, setNavigationLoading} = props;

  const {shopContextState, shopContextDispatch} = useShopContext();
  const {shopNavItems, shopAllNavItems, shopNavItemsLoaded} = shopContextState;

  const allowMegaRequest = groheFiltersSearchText.length > 2;

  const startLoadingAdditionalFeatures = async (scrolling = true) => {
    setNavigationLoading(true);
    if (scrolling) {
      await new Promise(resolve => setTimeout(resolve, 300));
    }
    await getAdditionalFeaturesOnScroll(featureGroup);
    await setReceivedFeatures();
    if (scrolling) {
      await new Promise(resolve => setTimeout(resolve, 300));
    }
    setNavigationLoading(false);
  }

  const getFeatureGroupNavItems = (forFeatureGroup, layout) => {
    let navFeatures = layout.designNavigationItems(
      {part: forFeatureGroup},
      selectedFilters,
      groheFiltersSearchText,
      forFeatureGroup.activeFeature,
      true,
      filterGroups,
      {returnAllFeatures: true} // here we request all features
    );
    navFeatures = getReorderedItems(navFeatures,null, forFeatureGroup.partId, forFeatureGroup);
    const shopAllNavItems = layout.designNavigationItems(
      {part: forFeatureGroup},
      [],
      groheFiltersSearchText,
      forFeatureGroup.activeFeature,
      true,
      filterGroups,
      {returnAllFeatures: true} // here we request all features
    );
    return {navFeatures, shopAllNavItems}
  }

  const setReceivedFeatures = async () => {
    const layout = getCurrentLayout();

    let {navFeatures, shopAllNavItems} = getFeatureGroupNavItems(featureGroup, layout);

    if (allowMegaRequest) {
      const lookList = getLookList(false, true, false, true, false)
      for (const parentObject of lookList) {
        if (featureGroup.partId !== parentObject.featureGroup.partId) {
          const thisGroupObject = getFeatureGroupNavItems(parentObject.featureGroup, layout);
          navFeatures = [...navFeatures, ...thisGroupObject.navFeatures];
          shopAllNavItems = [...shopAllNavItems, ...thisGroupObject.shopAllNavItems];
        }
      }
    }

    shopContextDispatch(shopContextAction({shopNavItems: navFeatures, shopAllNavItems}));
    if (!shopNavItemsLoaded && featureGroup.allFeaturesReceived) {
      shopContextDispatch(shopContextAction({shopNavItemsLoaded: true}));
    }

    if (!featureGroup.getRealFeaturesReceivedProperty()) {
      setTimeout(() => {
        if (featureGroup.allFeaturesReceived && !featureGroup.getRealFeaturesReceivedProperty() && scrollElement && scrollElement.current
          && (scrollElement.current.clientHeight >= scrollElement.current.scrollHeight)
          && featureGroup.getNextPageToLoad() < 2) { // no need to make many requests, we should check why features are missing
          startLoadingAdditionalFeatures(false);
        }
      }, 500)
    }
  }

  useEffect(() => {
    setReceivedFeatures();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [featureGroup, selectedFilters, navigationCount, filterGroups])

  if (!scrollElement || !scrollElement.current) {
    return null
  }

  const onScrollHandler = async (scrollObject) => {
    if (!featureGroup) {
      return;
    }
    if (featureGroup.getRealFeaturesReceivedProperty() || !scrolledVerticalToTheEnd(scrollObject)) {
      return
    }
    startLoadingAdditionalFeatures();
  }

  if (!shopNavItemsLoaded) {
    return <MaterialSpinner/>
  }

  return (
    <Fragment>
      <ShopCategoryAside featureGroup={featureGroup}
                         multipleGroups={allowMegaRequest}
                         shopNavItems={shopAllNavItems}/>
      <ShopCategoryBackNextButtons/>
      <div className="shop-content">
        {!shopNavItems.length && shopNavItemsLoaded && !navigationLoadingActive ? (
          <h3 className="shop-content__center text-center">No features available</h3>
        ) : <ShopCategoryVirtualizedGrid renderList={shopNavItems}
                                         useSimpleView={useSimpleView}
                                         scrollElement={scrollElement.current}
                                         windowWidth={windowWidth}
                                         onScrollHandler={
                                           allFeaturesWereLoaded.includes(document.kvConfig.visualizerType) ? null : onScrollHandler
                                         }
                                         isMobile={isMobile}/>}
        {navigationLoadingActive ? <NavigationLoader className={" shop-overlay"}/> : null}
      </div>
    </Fragment>
  )
};

ShopCategoryList.propTypes = {
  scrollElement: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.node,
    PropTypes.shape({current: PropTypes.instanceOf(Element)})
  ]),
}

const mapStateToProps = (store) => {
  const {navigationCount} = store.lookState;
  const {selectedFilters, filterGroups} = store.filterState;
  const {isMobile, windowWidth, allFeaturesWereLoaded} = store.serverState;
  const {groheFiltersSearchText} = store.groheState;
  const {navigationLoadingActive} = store.navigationState;

  return {
    navigationCount,
    filterGroups,
    selectedFilters,
    isMobile,
    windowWidth,
    allFeaturesWereLoaded,
    groheFiltersSearchText,
    navigationLoadingActive,
  };
};

const mapDispatchToProps = {
  setNavigationLoading,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShopCategoryList)
)
